import React from "react";
import { ArrowRight, Download, FileText } from "lucide-react";
import SectionHeading from "@/components/site/SectionHeading";
import { CATALOGS, WHATSAPP_URL } from "@/lib/site";

export default function Catalogos() {
  return (
    <>
      <section className="bg-white border-b border-surface-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-bronze">Material técnico</div>
          <h1 className="mt-4 max-w-4xl font-display text-4xl font-black leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Catálogos e fichas <span className="text-brand">técnicas</span>.
          </h1>
          <p className="mt-6 max-w-3xl text-lg leading-relaxed text-ink-muted">
            Baixe o catálogo geral de equipamentos ou as fichas técnicas específicas por linha de produto. Envie as páginas ou referências desejadas ao nosso time para cotação.
          </p>
        </div>
      </section>

      <section className="bg-surface-alt py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeading eyebrow="Downloads" title="Todos os materiais disponíveis." subtitle="Documentos comerciais em PDF, organizados por linha técnica." />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {CATALOGS.map((cat) => (
              <article key={cat.slug} className="flex flex-col overflow-hidden rounded-lg border border-surface-line bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:shadow-xl">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#eef1f2] text-brand">
                  <FileText className="h-6 w-6" />
                </div>
                <div className="mt-5 text-xs font-bold uppercase tracking-[0.2em] text-bronze">{cat.tag}</div>
                <h2 className="mt-3 font-display text-xl font-bold leading-snug text-ink">{cat.title}</h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ink-muted">{cat.desc}</p>
                <a href={cat.file} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 font-semibold text-brand hover:text-brand-mid">
                  Baixar PDF <Download className="h-4 w-4" />
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-brand-noise py-20 text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="font-display text-3xl font-bold sm:text-4xl">Não encontrou a linha que precisa?</h2>
          <p className="mx-auto mt-4 max-w-2xl text-white/80">Fale com nosso time e envie fabricante, modelo, part number, quantidade e prazo.</p>
          <a href={WHATSAPP_URL("Olá! Preciso de ajuda para localizar um catálogo ou ficha técnica.")} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-4 font-semibold text-brand">
            Enviar minha demanda <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </section>
    </>
  );
}
